import React, {useEffect, useState, useContext} from 'react';
import {AuthContext} from "../../../config/AuthContext";
import '../../../styles/Commons.css';
import {Card, Checkbox, Col, Row, Table} from "antd";
import {User} from "../../../model/root/User";
import {Escola} from "../../../model/root/Escola";
import {ColumnsType} from "antd/es/table";
import {Rol} from "../../../model/root/Rol";
import {UsuariRolEscoles} from "../../../model/root/UsuariRolEscoles";
import {PutEscolaUsuari} from "../../../dao/root/PutEscolaUsuari";
import {PutRolUsuari} from "../../../dao/root/PutRolUsuari";
import {PostHorariUsuari} from "../../../dao/root/PutHorariUsuari";

interface element {
    element: User,
    elements: UsuariRolEscoles,
    page: string,
    checkDades: () => void,
    hoaris: any[],
}

const UsuarisList = (ele: element) => {
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);

    async function toggleEscola(id_escola: number) {
        await PutEscolaUsuari(id_escola, ele.element.id, ele.page, userId);
        await ele.checkDades(); // Llama a checkDades directamente aquí
    }

    async function togglePermis(id_rol: number) {
        await PutRolUsuari(id_rol, ele.element.id, ele.page, userId);
        await ele.checkDades(); // Llama a checkDades directamente aquí
    }

    async function toggleHorari(id: number) {
        await PostHorariUsuari(id, ele.element.id, ele.page, userId);
        ele.checkDades(); // Llama a checkDades directamente aquí
    }

    const columns: ColumnsType<Rol> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, el) => (
                <>
                    <Checkbox type={"toggle"}
                              disabled={el.nom == 'superusuari' || ele.element.nom.lastIndexOf("superusuari") !== -1}
                              checked={ele.element.rol && ele.element.rol.some((rol : Rol) => rol.id === el.id)}
                              onClick={() => togglePermis(el.id)}/>
                </>
            ),
        },
    ];
    const columns2: ColumnsType<Escola> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, el) => (
                <>
                    <Checkbox type={"toggle"}
                              disabled={el.nom == 'Altres Escoles' || ele.element.nom.lastIndexOf("superusuari") !== -1}
                              checked={ele.element.escoles && ele.element.escoles.some((escola: Escola) => escola.id === el.id)}
                              onClick={() => toggleEscola(el.id)}/>
                </>
            ),
        },
    ];

    const columns3: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, el) => (
                <>
                    <Checkbox type={"toggle"}
                              disabled={el.nom == 'superusuari' || ele.element.nom.lastIndexOf("superusuari") !== -1}
                              checked={ele.element.horaris && ele.element.horaris.some((horari: any) => horari.id === el.id)}
                              onClick={() => toggleHorari(el.id)}/>
                </>
            ),
        },
    ];

    const empresas = [
        {
            value: 0,
            id: 0,
            nom: "Art i Esports",
            label: "Art i Esports",
            page: ""
        },
        {
            value: 1,
            id: 1,
            nom: "Ambit Escola",
            label: "Ambit Escola",
            page: ""
        },
    ]

    return (
        <Card bordered={true}>
            <Row gutter={16}>
                <Col className="gutter-row" span={1}>
                </Col>
                <Col className="gutter-row" span={6}>
                    <h4 className={"subsubtitol"}>Rols</h4>
                    <Table tableLayout={"fixed"}
                        size={"small"}
                        columns={columns}
                        dataSource={ele.elements.rols}
                    />
                </Col>
                <Col className="gutter-row" span={2}>
                </Col>
                <Col className="gutter-row" span={6}>
                    <h4 className={"subsubtitol"}>Permisos d'Escoles</h4>
                    <Table tableLayout={"fixed"}
                           size={"small"}
                           columns={columns2}
                           dataSource={ele.elements.escoles}
                    />
                </Col>
                <Col className="gutter-row" span={2}>
                </Col>
                <Col className="gutter-row" span={6}>
                    <h4 className={"subsubtitol"}>Horari</h4>
                    <Table tableLayout={"fixed"}
                           size={"small"}
                           columns={columns3}
                           dataSource={ele.hoaris}
                    />
                </Col>
                <Col className="gutter-row" span={1}>
                </Col>
            </Row>
        </Card>
    );
};
export default UsuarisList;
